<template>
  <b-container>
    <div class="user-settings align-center">
      <h1 class="mt-4 text-center">
        User Settings
      </h1>
      <b-row class="justify-content-center">
        <b-col md="6" class="align-center">
          <b-form class="contact-form" @submit.prevent="deleteAccount">
            <b-form-group label="Name">
              <b-form-input
                v-model.trim="userInfo.name"
                disabled
                required
                type="text"
              />
            </b-form-group>
            <b-form-group label="Email">
              <b-form-input
                v-model.trim="userInfo.email"
                autocomplete="email"
                autofocus
                required
                type="email"
                disabled
              />
            </b-form-group>
            <b-form-group label="Phone Number">
              <b-form-input
                v-model.trim="userInfo.phone"
                required
                type="text"
                disabled
              />
            </b-form-group>
            <b-row align-h="center" class="mt-5">
              <b-button
                class="delete-account-button"
                type="submit"
              >
                Delete account
              </b-button>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      userInfo: {
        name: '',
        phone: '',
        email: '',
      },
    };
  },
  
  computed: {
    ...mapGetters(['user']),
  },
  
  created() {
    this.userInfo.email = this.user.email;
    this.userInfo.name = this.user.name;
    this.userInfo.phone = this.user.phone;
  },

  methods: {
    async deleteAccount() {
      try {
        await this.apiClient.delete('/customers/account');
        this.$store.dispatch('messenger/broadcast', [
          'success',
          'Your account has been scheduled for deletion.',
        ]);
        this.$store.dispatch('account/unloadUser');
        this.$router.push('/');
      } catch (error) {
        this.$store.dispatch('messenger/broadcast', [
          'error',
          'There was a problem deleting your account.',
        ]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.module.scss';
@include buttons;
@include inputs;

.delete-account-button {
  background-color: white;
  border-color: $danger;
  box-shadow: none;
  color: $danger;
  &:hover {
    background-color: $danger !important;
    border-color: $danger !important;
    color: $white !important;
  }
}
</style>
